<script lang="ts">
  import type { Session } from './drill/session.svelte';

  interface Props {
    session: Session;
    onhome: () => void;
  }

  let { session, onhome }: Props = $props();
  const s = $derived(session.summary());
</script>

<div class="page page-drill">
  <section class="panel done" aria-labelledby="done-title" data-testid="session-done">
    <h1 id="done-title" tabindex="-1">セッション結果</h1>
    <div class="num-hero" data-testid="done-correct">
      {s.correct}<span class="unit"> / {s.cards} 枚</span>
    </div>
    <p>{s.cards} 枚中 {s.correct} 枚で一致しました。</p>
    <div>
      <button class="btn btn-primary" type="button" onclick={onhome}>問題一覧に戻る</button>
    </div>
  </section>
</div>

<style>
  .done {
    display: flex;
    flex-direction: column;
    gap: var(--space-4);
  }
  .unit {
    font-size: var(--fs-xl);
    font-weight: var(--fw-bold);
  }
</style>
